import {CloseOutlined} from '@ant-design/icons'
import {useListViewCamera} from '../core/ListViewProviderCamera'

const DeviceInfoModalHeader = () => {
  const {setItemIdForCamera} = useListViewCamera()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Thông tin Camera</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForCamera({})}
        style={{cursor: 'pointer'}}
      >
        <CloseOutlined style={{fontSize: '16px'}} />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {DeviceInfoModalHeader}
